import { A } from "@/lib/authStyles";

export function AuthSpinner({ label = "Loading…" }: { label?: string }) {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: A.bg,
        color: A.text,
        display: "flex",
        flexDirection: "column",
        gap: 14,
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "'DM Sans', sans-serif",
      }}
    >
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
      <div
        style={{
          width: 38,
          height: 38,
          borderRadius: "50%",
          border: `3px solid ${A.border}`,
          borderTopColor: A.teal,
          animation: "spin .9s linear infinite",
        }}
      />
      <div style={{ color: A.sub, fontSize: 13 }}>{label}</div>
    </div>
  );
}
